<template>
  <div class="add">
    <header class="headet-title">
      <div class="headet-title-box">
        <p>修改手机号码</p>
      </div>
    </header>
    <div class="add-body">
      <el-form label-width="140px" style="padding-left:40px;">
        <el-form-item v-if="infoForm.customerType=='8'" label="联系人姓名：">
          <el-input
            v-model="oldContactName"
            style="width:339px"
            class="bN"
            readonly
          />
        </el-form-item>
        <el-form-item v-if="infoForm.customerType=='8'" label="联系人手机号：">
          <el-input
            v-model="oldPhoneMask"
            style="width:339px"
            class="bN"
            readonly
          />
        </el-form-item>
        <el-form-item v-if="infoForm.customerType=='6'" label="手机号：">
          <el-input
            v-model="oldPhoneMask"
            style="width:339px"
            class="bN"
            readonly
          />
        </el-form-item>
        <el-form-item v-if="infoForm.customerType=='8'" label="新的联系人姓名：">
          <el-input v-model="infoForm.contactName" style="width:263px" />
        </el-form-item>
        <el-form-item v-if="infoForm.customerType=='8'" label="新的联系人手机号：">
          <el-input v-model="infoForm.phone" style="width:263px" />
        </el-form-item>
        <el-form-item v-if="infoForm.customerType=='6'" label="新手机号：">
          <el-input v-model="infoForm.phone" style="width:263px" />
        </el-form-item>
        <el-form-item label="短信验证码：">
          <el-input v-model.number="infoForm.smsCode" placeholder="请输入短信验证码" style="width:263px">
            <template slot="append">
              <span v-show="show" @click="getSmsCode">获取验证码</span>
              <span v-show="!show" class="count">{{ count }} s</span>
            </template>
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-button class="sub" @click="editSubmit">提交</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>
<script>
import { getPersonalInfo, getCompanyInfo } from '@/api/info'
import { setNull } from '@/api/common/common'
import { getSmsCode, editPhone } from '@/api/security/security'
import Session from '@/utils/session'
import { getInfo } from '@/api/user'
import { SelectCertificateOnClick, SignOnClick } from '@/utils/CryptoKit'

export default {
  data() {
    return {
      show: true,
      count: '',
      timer: null,
      // 原客户姓名
      oldContactName: null,
      // 原客户手机号
      oldPhone: null,
      oldPhoneMask: null,
      infoForm: {
        // 客户id
        customerId: Session.getItem('customerId'),
        // 客户类型
        customerType: Session.getItem('customerType'),
        // 新客户姓名
        contactName: null,
        // 短信验证码
        smsCode: null,
        // 新手机号
        phone: null
      },
      smsParam: {
        // 平台编码 5-官网
        platform: '5',
        // 业务类型
        businessType: 'editPhone'
      }

    }
  },
  watch: {
    $route() {
      if (this.$route.name === 'editPhone') {
        this.getData()
      }
    }
  },
  created() {
    this.getData()
  },
  methods: {
    // 查询
    getData() {
      const param = {
        customerId: this.infoForm.customerId
      }
      if (this.infoForm.customerType === '6') {
        getPersonalInfo(param)
          .then(res => {
            const data = res.data
            this.oldPhone = data.phone
            this.oldPhoneMask = data.phoneMask
            this.infoForm.phone = null
            this.infoForm.smsCode = null
          })
          .catch(error => {
            console.log(error) // 请求失败返回的数据
          })
      } else {
        getCompanyInfo(param)
          .then(res => {
            const data = res.data
            this.infoForm.contactName = data.contactName
            this.oldPhone = data.contactPhone
            this.oldPhoneMask = data.contactPhoneMask
            this.oldContactName = data.contactName
            this.infoForm.phone = null
            this.infoForm.smsCode = null
          })
          .catch(error => {
            console.log(error) // 请求失败返回的数据
          })
      }
    },
    // 修改手机号
    editSubmit() {
      console.log(123)
      const form = setNull(this.infoForm)
      const param = Object.assign({}, form, this.smsParam)
      param.isCfcaDecrypt = SelectCertificateOnClick()
      param.contactName = SignOnClick(form.contactName).result
      param.phone = SignOnClick(form.phone).result
      editPhone(param)
        .then(res => {
          const infoParam = {
          }
          getInfo(infoParam).then(response => {
            Session.setItem('customerId', response.data.customerId)
            Session.setItem('customerType', response.data.customerType)
            Session.setItem('authFlag', response.data.authFlag)
            Session.setItem('phoneMask', response.data.customerPhoneMask)
            Session.setItem('phone', response.data.customerPhone)
            Session.setItem('customerCode', response.data.customerCode)
            this.$router.push({
              name: 'customerInfo'
            })
          })
        })
        .catch(error => {
          console.log(error) // 请求失败返回的数据
        })
    },
    // 获取短信验证码
    getSmsCode() {
      if (this.infoForm.phone === '' || this.infoForm.phone == null) {
        this.$message({
          message: '请输入新手机号',
          type: 'error'
        })
        return
      }
      const phoneReg = /^[1][0-9]{10}$/
      if (!phoneReg.test(this.infoForm.phone)) {
        this.$message({
          message: '手机号格式不正确',
          type: 'error'
        })
        return
      }
      if (this.oldPhone === this.infoForm.phone) {
        this.$message({
          message: '新手机号不能与原手机号相同',
          type: 'error'
        })
        return
      }
      const form = {
        templateCode: '20191230204159',
        verificationFlag: '1',
        phoneNumber: this.infoForm.phone
      }
      const param = Object.assign({}, form, this.smsParam)
      param.isCfcaDecrypt = SelectCertificateOnClick()
      param.phoneNumber = SignOnClick(this.infoForm.phone).result
      getSmsCode(param)
        .then(res => {
          this.$message({
            message: '验证码已发送',
            type: 'success'
          })
          const TIME_COUNT = 60
          if (!this.timer) {
            this.count = TIME_COUNT
            this.show = false
            this.timer = setInterval(() => {
              if (this.count > 0 && this.count <= TIME_COUNT) {
                this.count--
              } else {
                this.show = true
                clearInterval(this.timer)
                this.timer = null
              }
            }, 1000)
          }
        })
        .catch(error => {
          console.log(error) // 请求失败返回的数据
        })
    }
  }
}
</script>
<style>
.bN .el-input__inner {
  border: none;
  padding: 0;
}
</style>
<style scoped>
.add-body ::v-deep.el-form-item ::v-deep.ocx_style:focus {
  outline: none;
  border: 1px solid #f56c6c;
}
.add {
  padding-bottom: 118px;
}
.bN .el-input__inner {
  border: none;
}
.headet-title {
  padding: 10px 30px 20px 30px;
}
.headet-title .headet-title-box {
  font-size: 16px;
  padding: 10px 0;
  font-weight: 500;
  color: rgba(51, 51, 51, 1);
  border-bottom: 1px solid #dbdde2;
}
.headet-title-box {
  display: flex;
  align-items: center;
}
.headet-title-box > p:first-of-type {
  margin-right: 26px;
}

.add-body ::v-deep .el-input__inner {
  height: 32px;
  font-size: 13px;
  line-height: 36px;
  border-radius: 0px;
}
.get {
  width: 106px;
  height: 32px;
  border-radius: 0px;
  background: #ffffff;
  border: 1px solid #dcdcdc;
  color: #5e5e5e;
  margin-left: 10px;
  font-size: 13px;
  padding: 0;
}
.sub {
  width: 118px;
  height: 40px;
  background: #e50007;
  color: #ffffff;
  border-radius: 0px;
  margin-top: 23px;
}
.back {
  color: #5e5e5e;
  background: #ffffff;
}
.forget {
  margin-left: 29px;
  color: #498aea;
  font-size: 13px;
}
</style>
